import { Box } from '@mui/material';
import PricesTable from '../../components/Tables/PricesTable';

const PricesPage = () => {
    return <Box>
        <PricesTable/>
    </Box>;
}

export default PricesPage;